import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../../styles/admin/direccion.css';
import * as globals from './../../components/GlobalScripts.js';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '400px'
};

const defaultCenter = {
    lat: -0.180653,
    lng: -78.467834
};

const Admin_direccion = () => {
    let path_api = localStorage.getItem('path_api');
    const [formDataAddress, setFormDataAddress] = useState({});

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyBYnh7Tl6Z724ZL3Z_VqCgrUVKPSwGE7l4',
    });

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            if (userParsed.address) {
                setFormDataAddress(userParsed.address);
            }
        }
    }, []);

    const updateMap = () => {
        const { direccion, estado, ciudad, colonia, cp } = formDataAddress;
        if (direccion && estado && ciudad && colonia && cp) {
            const fullAddress = `${direccion}, ${colonia}, ${ciudad}, ${estado}, ${cp}`;
            geocodeAddress(fullAddress);
        }
    };

    const geocodeAddress = (address) => {
        if (!isLoaded || !window.google) return;
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const location = results[0].geometry.location;
                setFormDataAddress(prev => ({
                    ...prev,
                    lat: location.lat(),
                    lng: location.lng()
                }));
            } else {
                globals.createAlert({
                    type: 'error',
                    msg_title: 'Error',
                    msg: 'No se pudo obtener la ubicación de la dirección.',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            }
        });
    };

    const handleSubmit_address = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/update-clients/address.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            address: formDataAddress,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Exito",
                    msg: "Tu cuenta se actualizo sin problemas.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setFormDataAddress(response.data.user.address);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "Tu cuenta no se ha actualizo",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar la cuenta",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange_address = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataAddress({ ...formDataAddress, [name]: newValue });
    };

    const handleMapClick = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setFormDataAddress(prev => ({ ...prev, lat, lng }));
    };

    const handleMarkerDragEnd = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setFormDataAddress(prev => ({ ...prev, lat, lng }));
    };

    return (
        <>
            <div className='page-direccion container-section medium-section flex-column gap-20'>
                <form onSubmit={handleSubmit_address} className="flex-column gap-20">
                    <h3>Dirección de entrega</h3>
                    <div className="form-group">
                        <label htmlFor="direccion">Dirección</label>
                        <input
                            type="text"
                            id="direccion"
                            name="direccion"
                            value={formDataAddress.direccion}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder="roma #123"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="referencia">Referencia</label>
                        <input
                            type="text"
                            id="referencia"
                            name="referencia"
                            value={formDataAddress.referencia}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder=""
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="apartamento">Apartamento</label>
                        <input
                            type="text"
                            id="apartamento"
                            name="apartamento"
                            value={formDataAddress.apartamento}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder=""
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="estado">Provincia</label>
                        <input
                            type="text"
                            id="estado"
                            name="estado"
                            value={formDataAddress.estado}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder=""
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="ciudad">Ciudad</label>
                        <input
                            type="text"
                            id="ciudad"
                            name="ciudad"
                            value={formDataAddress.ciudad}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder=""
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="colonia">Sector</label>
                        <input
                            type="text"
                            id="colonia"
                            name="colonia"
                            value={formDataAddress.colonia}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder=""
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="cp">Código postal</label>
                        <input
                            type="number"
                            id="cp"
                            name="cp"
                            value={formDataAddress.cp}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder=""
                            required
                        />
                    </div>
                    {isLoaded && (
                        <div className="map-container">
                            <p>Direccion: {formDataAddress?.direccion}, {formDataAddress?.colonia}, {formDataAddress?.ciudad}, {formDataAddress?.estado}, {formDataAddress?.cp}</p>
                            <GoogleMap
                                mapContainerStyle={containerStyle}
                                center={{
                                    lat: formDataAddress.lat || defaultCenter.lat,
                                    lng: formDataAddress.lng || defaultCenter.lng
                                }}
                                zoom={15}
                                onClick={handleMapClick}
                                options={{
                                    zoomControl: true,
                                    zoomControlOptions: {
                                        position: window.google && window.google.maps ? window.google.maps.ControlPosition.RIGHT_CENTER : undefined
                                    }
                                }}
                            >
                                {formDataAddress.lat && formDataAddress.lng && (
                                    <Marker
                                        position={{ lat: formDataAddress.lat, lng: formDataAddress.lng }}
                                        draggable={true}
                                        onDragEnd={handleMarkerDragEnd}
                                    />
                                )}
                            </GoogleMap>
                        </div>
                    )}
                    <span className="button-primary yellow" onClick={updateMap}>
                        Verifica tu ubicacion (actualizar mapa)
                    </span>

                    <div className="form-group">
                        <label htmlFor="lat">Latitud</label>
                        <input
                            type="text"
                            id="lat"
                            name="lat"
                            value={formDataAddress.lat}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder="Verifica para cargar"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="lng">Longitud</label>
                        <input
                            type="text"
                            id="lng"
                            name="lng"
                            value={formDataAddress.lng}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder="Verifica para cargar"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="comentarios">Comentarios</label>
                        <textarea
                            type="text"
                            id="comentarios"
                            name="comentarios"
                            value={formDataAddress.comentarios}
                            onChange={handleChange_address}
                            className="input-primary"
                            placeholder="..."
                            rows="3"
                        />
                    </div>
                    <div className="buttons-opt">
                        <button className="button-primary" type="submit">
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default Admin_direccion;
